export function parselyTracker({ url, referrer } = {}) {
    if (
        !window.PARSELY ||
        !("beacon" in window.PARSELY) ||
        !("trackPageView" in window.PARSELY.beacon)
    ) {
        return;
    }

    window.PARSELY.beacon.trackPageView({
        url,
        urlref: referrer,
        js: 1,
        action_name: "video",
    });
}
